import { Injectable } from '@angular/core';

@Injectable()
export class DistanceService {
  radiusUnits = {
    'feet': 20908800,
    'yards': 6969600,
    'miles': 3960,
    'mi': 3960,
    'kilometers': 6371,
    'km': 6371,
    'meters': 6371000
  }

  getDistance(start, end, options = { unit: 'kilometers' }) {
    let coordsStart = this.parseCoordinates(start);
    let coordsEnd = this.parseCoordinates(end);

    let R = this.getEarthRadius(options.unit)
    let lat1 = coordsStart[0];
    let lat2 = coordsEnd[0];
    let lon1 = coordsStart[1];
    let lon2 = coordsEnd[1];
    let φ1 = lat1 * Math.PI / 180;
    let φ2 = lat2 * Math.PI / 180;
    let Δφ = (lat2 - lat1) * Math.PI / 180;
    let Δλ = (lon2 - lon1) * Math.PI / 180;

    let a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) *
      Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    let d = R * c;

    return d;
  }

  parseCoordinates(point = [0, 0]) {

    let coords = []

    if (point instanceof Array) {
      coords = point
    }
    else {
      if (point[0] && point[1]) {
        coords = [point[0], point[1]]
      }
    }
    return coords;
  }

  getEarthRadius(unit = "kilometers") {
    return this.radiusUnits[unit.toLowerCase()];
  }

}
